import SideTool from "@/global/components/side-tool";
import { Station, StationItem } from "@/global/interface/archi/station";
import { useEffect, useState } from "react";
import "./index.less"
import { ReactComponent as ShowSvg } from './icons/show.svg'
import { ReactComponent as DeleteSvg } from './icons/delete.svg'
import classNames from "classnames";
import { message } from "antd";
import { STATION_ITEM_TYPE, STATION_TYPE } from "@/enums/station-type";
import AddStationModal from "./add-station-modal";
import { deleteStationByUuidList, findStationListByProjectId, updateStation, updateStationItem } from "@/api/archi/station";
import { useParams } from "react-router-dom";
import { StationCanvas, generateStationName, generateStationPrimitive } from "@/global/utils/station-utils";
import TnInput from "@/global/components/input/tn-input";
import PlaceButton from "@/global/components/place-button";
import { graphicStore } from "@/global/store/graphic-store";
import { ContextMenuFC } from "tncet-common";
import { ARCHI_SUB_CONTROL } from "@/passets/archibase-engine/enums/archi-sub-control";

// 正整数正则匹配
const intRegex = /^[0-9]\d*$/
// 正float正则匹配
const floatRegex = /^\d*\.?\d+$/;
export default function StationPanel() {

    const { projectId } = useParams()
    // 站台列表
    const [stationList, setStationList] = useState<Station[]>([])
    // 页面展开的列表项
    const [activeUuidList, setActiveUuidList] = useState<string[]>([])
    // 添加弹窗显隐
    const [modelVisible, setModelVisible] = useState<boolean>(false)
    // 是否展开右键菜单
    const [cmOpen, setCmOpen] = useState<boolean>(false);
    const [top, setTop] = useState<number>();
    const [left, setLeft] = useState<number>();
    useEffect(() => {
        generateData()
    }, [projectId, modelVisible])

    const generateData = () => {
        if (projectId) {
            findStationListByProjectId(projectId).then(res => {
                let stationList: Station[] = res.data || []
                for (let i = 0; i < stationList.length; i++) {
                    stationList[i].name = generateStationName(stationList[i])
                }
                setStationList(stationList)
            })
        }

    }

    // 获取input前的名字
    const getItemName = (item: StationItem) => {
        let resStr = ""
        if (item?.type == STATION_ITEM_TYPE.STATION) {
            resStr = "A"
        } else {
            resStr = "B"
        }
        return resStr + (item.level) + ":"
    }

    // 控制每个站台详细信息显隐
    const showStationItem = (uuid: string) => {
        if (activeUuidList.find(item => item == uuid)) {
            setActiveUuidList(activeUuidList.filter(item => item != uuid))
        } else {
            setActiveUuidList([...activeUuidList, uuid])
        }
    }

    // 输入框修改站台、股道值->修改数据库
    const stationItemInputOnBlur = (item: StationItem, value: string) => {
        if (!floatRegex.test(value)) {
            message.warning("输入非法！")
            return
        }
        // 判断值是否修改
        if (item.width.toString() == value) {
            return
        }

        updateStationItem(item.id, { width: Number(value) }).then(res => {
            let changeStationIndex = stationList.findIndex(i => i.uuid == item.stationId)
            if (stationList[changeStationIndex]) {
                let changeList = stationList[changeStationIndex]?.itemList || []
                for (let i = 0; i < changeList.length; i++) {
                    if (changeList[i].id == item.id) {
                        changeList[i].width = Number(value)
                        break;
                    }
                }
                let midStationList = [...stationList]
                midStationList[changeStationIndex].itemList = changeList
                setStationList([...midStationList])
            }
            message.success("修改成功！")
        }).catch((e) => {
            message.error("修改失败！")
        })
    }

    // 站台本身信息修改，L长度，H高度
    const stationValueChange = (station: Station, value: string, type: string) => {
        if (!floatRegex.test(value)) {
            message.warning("输入非法！")
            return
        }
        if (type == "H") {
            if (value == station?.height.toString()) {
                return
            }
            updateStation(station.uuid, { height: Number(value) }).then(() => {
                message.success("修改成功！")
                let changeList = [...stationList]
                let changeIndex = changeList.findIndex(i => i.id == station.id)
                changeList[changeIndex].height = Number(value)
                setStationList([...changeList])
            }).catch((e) => {
                message.error("修改失败！")
            })
        } else if (type == "L") {
            if (value == station?.length.toString()) {
                return
            }
            updateStation(station.uuid, { length: Number(value) }).then(() => {
                let changeList = [...stationList]
                let changeIndex = changeList.findIndex(i => i.id == station.id)
                changeList[changeIndex].length = Number(value)
                setStationList([...changeList])
                message.success("修改成功！")
            }).catch((e) => {
                message.error("修改失败！")
            })
        }
    }

    const onPlaceClick = (e, item: Station) => {
        e.stopPropagation();
        let lineList = generateStationPrimitive(item)
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(ARCHI_SUB_CONTROL.ASSIGNSTATIONCONTROL.name);
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.setInitControlData.dispatch(
            {
                originLines: lineList,
                stationFirst: item.type == STATION_TYPE.STATION_FIRST,
                length: item.length * 1000,
                projectUuid: projectId
            }
        )
    }

    const onRightClick = (e, stationId) => {
        e.preventDefault();
        // showStationItem(stationId)
        if (!activeUuidList.find(item => item == stationId)) {
            setActiveUuidList([stationId, ...activeUuidList])
        }
        setTop(e.clientY);
        setLeft(e.clientX);
        setCmOpen(true);
    }

    const deleteItem = () => {
        if (activeUuidList?.length > 0) {
            // deleteStationByUuid
            deleteStationByUuidList(activeUuidList).then(res => {
                message.success("删除成功！")
                let midStationList = stationList.filter(item => !activeUuidList.find(uuid => uuid == item.uuid))
                setStationList([...midStationList])
                setActiveUuidList([])
            }).catch((e) => {
                message.error("删除失败！")
            })
        }
        setCmOpen(false)
    }

    // 站台item的input框
    function ItemInput(props: { item: StationItem }) {
        return (
            <div className="detail-input">
                <div className="title">
                    {getItemName(props.item)}
                </div>
                <div className="input">
                    <TnInput
                        size="small"
                        onBlur={(e) => { stationItemInputOnBlur(props.item, e) }}
                        defaultValue={props.item?.width.toString() || "0"}
                    />
                </div>
                <div className="suffix">
                    M
                </div>
            </div>
        )
    }

    return (
        <div className="station-main">
            <SideTool
                onAddClick={() => { setModelVisible(true) }}
                onDeleteClick={() => { deleteItem() }}
            />
            <div className="list-main">
                {stationList?.map((station, index) => (
                    <div className="list-item" key={index}>
                        <div
                            className={classNames({
                                "name": true,
                                "name-active": activeUuidList?.find(item => item == station?.uuid)
                            })}
                            onClick={() => { showStationItem(station.uuid) }}
                            onContextMenu={(e) => {
                                onRightClick(e, station.uuid)
                            }}
                        >
                            {station?.name || "unnknowName"}
                            <ShowSvg className={classNames({
                                "name-icon": true,
                                "name-icon-show": activeUuidList?.find(item => item == station?.uuid)
                            })} />
                            {activeUuidList?.find(item => item == station?.uuid) && (
                                <div className="place-btn">
                                    <PlaceButton onClick={(e) => { onPlaceClick(e, station) }} />
                                </div>
                            )}
                        </div>
                        {activeUuidList?.find(item => item == station?.uuid) && (
                            <div className="station-detail">
                                <div className="canvas-area">
                                    <div className="canvas-scroll">
                                        <StationCanvas station={station} />
                                    </div>
                                </div>
                                <div className="item-list">
                                    {station?.itemList?.map((item) => (
                                        <ItemInput item={item} />
                                    ))}
                                    <div className="detail-input">
                                        <div className="title">
                                            {"H:"}
                                        </div>
                                        <div className="input">
                                            <TnInput
                                                size="small"
                                                onBlur={(e) => { stationValueChange(station, e, "H") }}
                                                defaultValue={station?.height.toString() || "0"}
                                            />
                                        </div>
                                        <div className="suffix">
                                            M
                                        </div>
                                    </div>
                                    <div className="detail-input">
                                        <div className="title">
                                            {"L:"}
                                        </div>
                                        <div className="input">
                                            <TnInput
                                                size="small"
                                                onBlur={(e) => { stationValueChange(station, e, "L") }}
                                                defaultValue={station?.length.toString() || "0"}
                                            />
                                        </div>
                                        <div className="suffix">
                                            M
                                        </div>
                                    </div>
                                </div>

                            </div>
                        )}
                        <div className="hr" />
                    </div>
                ))}
            </div>
            <AddStationModal visible={modelVisible} setVisible={setModelVisible} />
            <ContextMenuFC
                visible={cmOpen}
                top={top}
                left={left}
                width={104}
                wrapperClassname='delete-station-menu'
                onCancel={() => { setCmOpen(false) }}
            >
                <div className='item' onClick={() => { deleteItem() }}>
                    <DeleteSvg className="icon" />
                    <div className="name">
                        删除
                    </div>
                </div>
            </ContextMenuFC>
        </div>
    )
}